import React from 'react';
import iconSizes from 'constants/iconSizes.js';

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
};

const LinkAngeledIcon = ({ size = 'sm', color = 'none', style: overrideStyles = {}, fill = 'rgb(0%,0%,0%)', ...attr }) => {


  return (
    <svg style={{ ...style, ...overrideStyles }} xmlns="http://www.w3.org/2000/svg" {...iconSizes[size]} viewBox="0 0 16 16" version="1.1" {...attr}>
      <g id="surface1">
        <path style={{ stroke: color, fillRule: 'nonzero', fill, fillOpacity: '1' }} d="M 3.269531 7.347656 L 4.039062 7.792969 L 3.152344 9.332031 C 2.171875 11.03125 2.753906 13.207031 4.453125 14.1875 C 6.152344 15.171875 8.328125 14.589844 9.308594 12.886719 L 10.199219 11.347656 L 10.96875 11.792969 L 10.082031 13.332031 C 8.851562 15.457031 6.132812 16.1875 4.007812 14.957031 C 1.882812 13.730469 1.15625 11.011719 2.382812 8.886719 Z M 12.746094 8.714844 L 11.976562 8.269531 L 12.867188 6.730469 C 13.847656 5.027344 13.265625 2.855469 11.566406 1.871094 C 9.863281 0.890625 7.6875 1.472656 6.707031 3.171875 L 5.820312 4.714844 L 5.050781 4.269531 L 5.9375 2.730469 C 7.164062 0.601562 9.882812 -0.125 12.007812 1.101562 C 14.132812 2.328125 14.863281 5.046875 13.636719 7.171875 Z M 6.617188 11.332031 L 5.847656 10.886719 L 9.402344 4.730469 L 10.171875 5.171875 Z M 6.617188 11.332031" />
      </g>
    </svg>
  );
};

export default LinkAngeledIcon;



